import React from 'react'
import { InputRadio, InputRadioProps } from '../../../../Component/EnhancedData/InputRadio'
import { TaxOptionType } from '../../../../Type/EnhancedData'

interface TaxOption {
  label: string
  value: TaxOptionType
}

const taxItemOne: TaxOption = {
  label: 'Enter in tax amount for the entire transaction',
  value: 'transaction',
}

const taxItemTwo: TaxOption = {
  label: 'Enter in tax amount for each line item',
  value: 'line-item',
}

const taxItemThree: TaxOption = {
  label: 'This transaction is tax-exempt',
  value: 'exempt',
}

const taxInformation: InputRadioProps<TaxOptionType> = {
  name: 'tax info',
  label: 'How would you like to enter in your tax information?',
  items: [taxItemOne, taxItemTwo, taxItemThree],
}

interface TaxInformationProps {
  selectedTaxOption: TaxOptionType;
  onTaxOptionChange: (value: TaxOptionType) => void;
}

export function TaxInformation ({ selectedTaxOption, onTaxOptionChange }: TaxInformationProps) {
  return (
    <div className='tax-information'>
      <h1 style={{ color: 'black' }}>Tax Information</h1>
      <InputRadio
        {...taxInformation}
        value={selectedTaxOption}
        onChange={onTaxOptionChange}
      />
    </div>
  )
}
